module.exports = __webpack_public_path__ + "static/media/bg4.9568d191.jpg";